import { Avatar, Box, Typography } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { FC } from 'react'
import { stringAvatar } from 'components/DataGrid/gridOperators'
import { DensityStyleTypes } from 'types'

interface MtbOrgCellProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
  handleRowClick: (orgId: string) => void
}

const OptsOrgCell: FC<MtbOrgCellProps> = ({ params, densityStyles, handleRowClick }) => {
  const { organization } = params?.row ?? null
  const value = organization?.name ?? ''
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        pt: densityStyles.padding,
        pb: densityStyles.padding,
        pr: densityStyles.padding,
        gap: densityStyles.gap,
        width: '100%',
        cursor: 'pointer',
      }}
      onClick={() => handleRowClick(organization?.PK)}
    >
      <>
        {/* avatar only on parent rows */}
        {organization?.photoUrl ? (
          <Avatar
            src={organization.photoUrl}
            sx={{
              width: densityStyles.avatarSize,
              height: densityStyles.avatarSize,
              objectFit: 'cover',
              objectPosition: 'center',
              ml: 1,
            }}
            alt={value}
          />
        ) : (
          <Avatar
            {...stringAvatar(value, densityStyles)}
            sx={{
              backgroundColor: 'rgb(114, 229, 218)',
              width: densityStyles.avatarSize,
              height: densityStyles.avatarSize,
              ml: 1,
            }}
            alt={value}
          />
        )}

        {/* finally, the row label */}
        <Typography
          sx={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            fontSize: densityStyles.fontSize,
            fontWeight: 600,
            ml: 1,
          }}
        >
          {value}
        </Typography>
      </>
    </Box>
  )
}

export default OptsOrgCell
